import { t as N } from "./theme-B90C-74v.js";
import { t as p } from "./mergeClassNames-BHKm1BNi.js";
import { jsx as a, jsxs as f } from "react/jsx-runtime";
import { Popover as e } from "@base-ui/react/popover";
import { Menu as i } from "@base-ui/react/menu";
var b = "_positioner_1io0s_1", T = "_popup_1io0s_5", h = "_title_1io0s_29", q = "_description_1io0s_36", C = "_arrow_1io0s_42", s = {
  positioner: b,
  popup: T,
  title: h,
  description: q,
  arrow: C
}, L = ({ className: r, ...o }) => /* @__PURE__ */ a(e.Description, {
  ...o,
  className: p(s.description, r)
}), M = ({ side: r = "bottom", align: o = "center", sideOffset: l = 8, alignOffset: _, arrow: n = !1, anchor: u, container: v, keepMounted: m, className: c, children: d, ...g }) => {
  const P = N();
  return /* @__PURE__ */ a(e.Portal, {
    container: v ?? P ?? void 0,
    keepMounted: m,
    children: /* @__PURE__ */ a(e.Positioner, {
      side: r,
      align: o,
      sideOffset: l,
      alignOffset: _,
      anchor: u,
      className: s.positioner,
      children: /* @__PURE__ */ f(e.Popup, {
        ...g,
        className: p(s.popup, c),
        children: [n && /* @__PURE__ */ a(e.Arrow, { className: s.arrow }), d]
      })
    })
  });
}, w = ({ className: r, ...o }) => /* @__PURE__ */ a(e.Title, {
  ...o,
  className: p(s.title, r)
}), z = {
  Root: e.Root,
  Trigger: e.Trigger,
  Popup: M,
  Title: w,
  Description: L,
  Close: e.Close
}, G = "_positioner_il1sq_1", x = "_popup_il1sq_5", D = "_group_il1sq_36", $ = "_groupLabel_il1sq_42", j = "_separator_il1sq_54", t = {
  positioner: G,
  popup: x,
  group: D,
  groupLabel: $,
  separator: j
}, B = ({ className: r, ...o }) => /* @__PURE__ */ a(i.Group, {
  ...o,
  className: p(t.group, r)
}), E = ({ className: r, ...o }) => /* @__PURE__ */ a(i.GroupLabel, {
  ...o,
  className: p(t.groupLabel, r)
}), F = ({ className: r, ...o }) => /* @__PURE__ */ a(i.Separator, {
  ...o,
  className: p(t.separator, r)
});
export {
  z as a,
  t as i,
  E as n,
  B as r,
  F as t
};
